/**
 * Maps a TETR.IO rank onto the club palette.
 *
 * Rather than importing eighteen official rank colours that would fight the
 * marigold ground, each tier borrows one of the seven spot inks. The ladder
 * still reads top to bottom, and nothing new enters the palette.
 *
 * The foreground is chosen per tier so every chip clears WCAG AA (4.5:1)
 * against its own background — a few of these inks are too dark for ink text
 * and a few are far too light for white.
 */

export interface RankInk {
  readonly background: string;
  readonly foreground: string;
}

const INK = "var(--color-ink)";
const WHITE = "#ffffff";

const TIERS: readonly (readonly [prefixes: readonly string[], ink: RankInk])[] = [
  [["x+", "x"], { background: "var(--color-piece-t)", foreground: WHITE }],
  [["u"], { background: "var(--color-piece-z)", foreground: WHITE }],
  [["ss"], { background: "var(--color-piece-l)", foreground: INK }],
  [["s+", "s", "s-"], { background: "var(--color-piece-o)", foreground: INK }],
  [["a+", "a", "a-"], { background: "var(--color-piece-s)", foreground: INK }],
  [["b+", "b", "b-"], { background: "var(--color-piece-i)", foreground: INK }],
  [["c+", "c", "c-"], { background: "var(--color-piece-j)", foreground: WHITE }],
];

const UNRANKED: RankInk = { background: "transparent", foreground: INK };
const LOWEST: RankInk = { background: "var(--color-ink-soft)", foreground: WHITE };

export function rankInk(rank: string | null): RankInk {
  if (!rank) return UNRANKED;
  const match = TIERS.find(([prefixes]) => prefixes.includes(rank));
  return match ? match[1] : LOWEST;
}
